import { useAtomValue } from 'jotai'
import { autoLoadMediaAtom } from '@/atoms/preferences'
import { cn } from '@/lib/utils'
import { Event } from '@nostr/tools/wasm'
import { useMemo } from 'react'
import Content from '../Content'
import Image from '../Image'
import MediaPlayer from '../MediaPlayer'

export default function PodcastEpisode({ event, className }: { event: Event; className?: string }) {
  const autoLoadMedia = useAtomValue(autoLoadMediaAtom)
  const title = useMemo(() => event.tags.find((t) => t[0] === 'title')?.[1], [event])
  const image = useMemo(() => event.tags.find((t) => t[0] === 'image')?.[1], [event])
  const description = useMemo(() => event.tags.find((t) => t[0] === 'description')?.[1], [event])
  const audios = useMemo(
    () =>
      event.tags
        .filter((t) => t[0] === 'audio')
        .map((t) => t[1])
        .filter(Boolean),
    [event]
  )

  return (
    <div className={cn('space-y-2', className)}>
      <div className="font-medium">Podcast Episode</div>
      <div className="flex gap-4">
        {image && autoLoadMedia && (
          <Image
            imageUrl={image}
            imagePubkey={event.pubkey}
            className="aspect-square bg-foreground h-20"
            hideIfError
          />
        )}
        <div className="flex-1 w-0 space-y-1">
          {title && <div className="text-xl font-semibold line-clamp-1">{title}</div>}
          {description && (
            <div className="text-sm text-muted-foreground line-clamp-4">{description}</div>
          )}
        </div>
      </div>
      {audios.map((src) => (
        <MediaPlayer key={src} src={src} className="mt-2" />
      ))}
      {event.content && <Content event={event} />}
    </div>
  )
}
